import { render, staticRenderFns } from "./ClubExchange.vue?vue&type=template&id=1a7a2f2a"
import script from "./ClubExchange.vue?vue&type=script&lang=js"
export * from "./ClubExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports